import request from "@/plugins/axios";

/** S 商城列表 **/
// 商城列表
export const apiShopLists = (params: any) =>
  request.get("/shop.shop/lists", { params });

// 添加商城
export const apiShopAdd = (params: any) =>
  request.post("/shop.shop/add", params);

// 商城详情
export const apiShopDetail = (params: any) =>
  request.get("/shop.shop/detail", { params });

// 编辑商城
export const apiShopEdit = (params: any) =>
  request.post("/shop.shop/edit", params);

// 删除商城
export const apiShopDelete = (params: any) =>
  request.post("/shop.shop/delete", params);

// 修改超级管理员
export const apiShopChangeSuperAdmin = (params: any) =>
  request.post("/shop.shop/changeSuperAdmin", params);

// 修改商城状态
export const apiShopSwitchStatus = (params: any) =>
  request.post("/shop.shop/switchStatus", params);

// 历史套餐
export const apisetMealLogLists = (params: any) =>
  request.get("/shop.shop/setMealLogLists", { params });

// 修改商城备注
export const apiChangeRemark = (params: any) =>
  request.post("/shop.shop/changeRemark", params);

export const apiChangeAmount = (params: any) =>
  request.post("/shop.shop/changeAmount", params);
/** E 商城列表 **/

/** S 套餐列表 **/
// 套餐列表
export const apiSetMealLists = (params: any) =>
  request.get("/shop.set_meal/lists", { params });

// 添加套餐
export const apiSetMealAdd = (params: any) =>
  request.post("/shop.set_meal/add", params);

// 套餐详情
export const apiSetMealDetail = (params: any) =>
  request.get("/shop.set_meal/detail", { params });

// 编辑套餐
export const apiSetMealEdit = (params: any) =>
  request.post("/shop.set_meal/edit", params);

// 删除套餐
export const apiSetMealDelete = (params: any) =>
  request.post("/shop.set_meal/del", params);

// 修改套餐状态
export const apiSetMealSwitchStatus = (params: any) =>
  request.post("/shop.set_meal/status", params);

export const apiMealModule = () => request.get("/shop.set_meal/getMealModule");
/** E 套餐列表 **/

// 设计师列表
export const apiDesignerLists = (params: any) =>
  request.get("/designer.designer/lists", { params });

/** 订单套餐 */
export const apiOrderMealLists = (params: any) =>
  request.get("/shop.services/lists", { params });

export const apiOrderMealAdd = (params: any) =>
  request.post("/shop.services/add", params);

export const apiOrderMealEdit = (params: any) =>
  request.post("/shop.services/edit", params);

export const apiOrderMealDelete = (params: any) =>
  request.post("/shop.services/del", params);

export const apiWithdrawList = (params: any) =>
  request.get("/Withdraw/lists", { params });

export const apiWithdrawConfig = (params: any) =>
  request.get("/Withdraw/getConfig", { params });

export const apiWithdrawConfigSet = (params: any) =>
  request.post("/Withdraw/setConfig", params);

export const apiWithdrawStatusSet = (params: any) =>
  request.post("/Withdraw/audit", params);

export const apiWithdrawUpVoucher = (params: any) =>
  request.post("/Withdraw/UpVoucher", params);

// 授权列表
export const apiAuthList = (params: any) =>
  request.get("/userStore/lists", { params });

//
export const apiGetHeader = (params: any) =>
  request.get("/userStore/getHeader", { params });

// 店铺统计
export const apiShopStatistics = (params: any) =>
  request.get("/shop.Shop_Money_log/lists", { params });

// 钱包类型列表
export const apiShopMoneyLogGetTypeList = (params: any) =>
  request.get("/shop.Shop_Money_log/getTypeList", { params });

/* 分销商 start */

// 分销商列表
export const apiDistributionDistributionLists = (params: any) =>
  request.get("/distribution.distribution/lists", { params });
// 新增分销商
export const apiDistributionDistributionAdd = (data: any) =>
  request.post("/distribution.distribution/add", data);
// 编辑分销商
export const apiDistributionDistributionEdit = (data: any) =>
  request.post("/distribution.distribution/edit", data);
// 分销商详情
export const apiDistributionDistributionDetail = (params: any) =>
  request.get("/distribution.distribution/detail", { params });
// 设置分销商上级
export const apiDistributionDistributionSetLeader = (data: any) =>
  request.post("/distribution.distribution/setLeader", data);
// 关联商户列表
export const apiDistributionDistributionRelationShop = (data: any) =>
  request.post("/distribution.distribution/relationShop", data);
// 添加关联商户
export const apiDistributionDistributionAddShop = (data: any) =>
  request.post("/distribution.distribution/addShop", data);
// 删除关联商户
export const apiDistributionDistributionDelShop = (data: any) =>
  request.post("/distribution.distribution/delShop", data);
// 提现列表
export const apiDistributionWithdrawLists = (params: any) =>
  request.get("/distribution.withdraw/lists", { params });
// 同意提现
export const apiDistributionWithdrawAllow = (data: any) =>
  request.post("/distribution.withdraw/allow", data);
// 拒绝提现
export const apiDistributionWithdrawReject = (data: any) =>
  request.post("/distribution.withdraw/reject", data);
// 确认打款
export const apiDistributionWithdrawComplete = (data: any) =>
  request.post("/distribution.withdraw/complete", data);
// 佣金记录
export const apiDistributionAccountLogLists = (params: any) =>
  request.get("/distribution.AccountLog/lists", { params });
// 类型列表
export const apiDistributionAccountLogTypeLists = (params: any) =>
  request.get("/distribution.AccountLog/typeLists", { params });
// 申报列表
export const apiDistributionCustomRegistrationLists = (params: any) =>
  request.get("/distribution.customRegistration/lists", { params });
// 申报列表通过
export const apiDistributionCustomRegistrationApprove = (data: any) =>
  request.post("/distribution.customRegistration/approve", data);
// 申报列表拒绝
export const apiDistributionCustomRegistrationReject = (data: any) =>
  request.post("/distribution.customRegistration/reject", data);
// 关系日志
export const apiDistributionDistributionRelationLog = (params: any) =>
  request.get("/distribution.distribution/relationLog", { params });

/* 分销商 end */

// 统计 start

// 账户统计数据
export const apiShopShopMoneyLogGetMoneyChartData = (params: any) =>
  request.get("/shop.ShopMoneyLog/getMoneyChartData", { params });

//商户订统计排序
export const apiShopShopStatistics = (params: any) =>
  request.get("/shop.shop/statistics", { params });
// 转单统计图表
export const apiOrderOrderGetOrderTransferTableChartsData = (params: any) =>
  request.get("/order.order/getOrderTransferTableChartsData", { params });
// 转单待结算图表
export const apiOrderOrderGetOrderTransferTableSettlementChartsData = (
  params: any,
) =>
  request.get("/order.order/getOrderTransferTableSettlementChartsData", {
    params,
  });

// 统计 end

//商户模型
export const apiShopModelList = (params: any) =>
  request.get("/model.modelList/getSidLists", { params });

//商户模型详情
export const apiShopModelListDetail = (params: any) =>
  request.get("/model.modelList/getSidDetail", { params });

export const apiShopMoneyData = (params: any) =>
  request.get("/shop.ShopMoneyLog/getShopMoneyData", { params });

export const apiShopNumberChartData = (params: any) =>
  request.get("/shop.shop_money_log/getShopNumberChartData", { params });
